import { render, staticRenderFns } from "./exitCarInfo.vue?vue&type=template&id=52257b8c&scoped=true"
import script from "./exitCarInfo.vue?vue&type=script&lang=js"
export * from "./exitCarInfo.vue?vue&type=script&lang=js"
import style0 from "./exitCarInfo.vue?vue&type=style&index=0&id=52257b8c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52257b8c",
  null
  
)

export default component.exports